export default abstract class TextUtil {
    public static getNumbersFormatted(num: number) {
        if (num <= 999) {
            return `${num}`
        } else if (num <= 999999) {
            return `${(num/1000).toFixed(1)}k`
        } else {
            return `${(num/1000000).toFixed(1)}m`
        }
    }
}